import React from 'react';
import { Box, Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PageHeaders from '../../../Utils/PageHeaders';
import PartnersSection from '../Home/components/PartnersSection';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';

// Sub-components
import LostFoundHero from './components/LostFoundHero';
import UnderstandingDatabase from './components/UnderstandingDatabase';
import HowItWorks from './components/HowItWorks';
import AccessDatabase from './components/AccessDatabase';
import PlanSponsors from './components/PlanSponsors';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(0),
    backgroundColor: '#FFFFFF',
    minHeight: '100vh',
  },
  contentContainer: {
    paddingTop: theme.spacing(2),
  },
}));

const FindOld401k = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <HubNav/>
      <PageHeaders
        title="Find Your Old 401k from a Previous Job — Free Tool | Plootus"
        description="Lost track of a 401k from an old job? Plootus helps you find forgotten retirement accounts for free — search your past employer's plan, recover your funds, and get AI-powered recommendations to put your money back to work."
        keywords="find old 401k, lost retirement accounts, forgotten 401k, unclaimed retirement money, 401k search"
        ogTitle="Find Your Lost 401k for Free | Plootus"
        ogDescription="Search old 401k plans from past employers and get free AI advice on what to do next. No SSN required."
        canonicalUrl="https://www.plootus.com/find-old-401k"
      />
      {/* Hero Section */}
      <LostFoundHero />

      {/* Main Content */}
      <Container maxWidth="lg" className={classes.contentContainer}>
        <UnderstandingDatabase />
        <AccessDatabase />
        <HowItWorks />
        <PlanSponsors />
      </Container>

      {/* Partners Section */}
      <PartnersSection />
    </Box>
  );
};

export default FindOld401k;
